/** Shared VMS request/visit status display (aligned with backend lifecycle). */

export const getVmsStatusBadge = (status) => {
  const upper = (status?.toString?.() || "").toUpperCase();
  if (upper === "REQUESTED") return { label: upper, colorScheme: "yellow" };
  if (upper === "APPROVED") return { label: upper, colorScheme: "green" };
  if (upper === "DECLINED") return { label: upper, colorScheme: "red" };
  if (upper === "RESCHEDULED") return { label: upper, colorScheme: "orange" };
  if (upper === "SIGNED_OUT") return { label: upper, colorScheme: "blue" };
  if (upper === "EXPIRED") return { label: upper, colorScheme: "gray" };
  if (!upper) return { label: "UNKNOWN", colorScheme: "gray" };
  return { label: upper, colorScheme: "gray" };
};

/** Human-readable label for `timestamps.signed_out_by` (and similar audit values). */
export const formatSignedOutBy = (value) => {
  if (value == null || value === "") return "-";
  const upper = String(value).toUpperCase();
  if (upper === "AUTO_EXPIRED") return "System (request expired at day end)";
  if (upper === "AUTO_END_OF_DAY") return "System (auto sign-out at day end)";
  if (upper === "PUBLIC_KIOSK") return "Public kiosk";
  return String(value).replace(/_/g, " ");
};

/** Gate / pass verify: treat as not valid for entry (matches typical backend rules). */
export const isPassNotValidForEntry = (status) => {
  const upper = (status?.toString?.() || "").toUpperCase();
  return upper === "EXPIRED" || upper === "SIGNED_OUT";
};
